<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";

    export default {
        name: "SpecificationDetail",
        props: {
            statusPage: String,
        },
        components: { TheDetailWrapper },
        data() {
            return {
                form: {
                    name: "",
                    sort: 0,
                    vendorId: this.$route.params.vendorId || "",
                    items: [
                        {
                            isMain: true,
                            code: "",
                            name: "",
                            sort: 0,
                        },
                    ],
                    status: "actual",
                },
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить спецификацию",
                    view: "Спецификация",
                    edit: "Редактировать спецификацию",
                };
                return filtered[this.statusPage];
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            }
        },
        methods: {
            send() {
                if (this.isNew) {
                    this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "VendorEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                this.$store.autoAdminApi
                    .editSpecification(this.$route.params.slug, this.form)
                    .then(() => {
                        this.$router.push({
                            name: "VendorView",
                            params: {
                                slug: this.form.vendorId,
                            },
                        });
                    });
            },
            handlerForCreate() {
                this.$store.autoAdminApi.createSpecification(this.form).then(({ data }) => {
                    this.$router.push({
                        name: "VendorView",
                        params: {
                            slug: this.form.vendorId,
                        },
                    });
                });
            },
            loadDataForEdited() {
                this.$store.autoAdminApi
                    .getSpecification(this.$route.params.slug)
                    .then(({ data }) => {
                        this.form = data;
                    });
            },
            addField() {
                this.form.items.push({ isMain: true, code: "", name: "", sort: 0 });
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <the-detail-wrapper
        :title="title"
        :type-list="`/vendor/${form.vendorId}`"
        :current-status="statusPage"
        @handler-submit="send"
    >
        <b-field label="Наименование">
            <b-input v-model="form.name"></b-input>
        </b-field>
        <b-field label="Сортировка">
            <b-input v-model.number="form.sort"></b-input>
        </b-field>
        <b-field label="Id производителя">
            <b-input v-model="form.vendorId" disabled></b-input>
        </b-field>

        <b-field label="Спецификации">
            <div class="columns">
                <div class="column is-2">
                    <b-field
                        label="Активность"
                        label-position="on-border"
                        v-for="(item, i) in form.items"
                        :key="i + 400"
                    >
                        <b-checkbox-button v-model="item.isMain">
                            {{ item.isMain ? "Вкл" : "Выкл" }}
                        </b-checkbox-button>
                    </b-field>
                </div>
                <div class="column is-7">
                    <b-field
                        label="Наименование"
                        label-position="on-border"
                        v-for="(item, i) in form.items"
                        :key="i + 100"
                    >
                        <b-input v-model="item.name"></b-input>
                    </b-field>
                </div>
                <div class="column is-1">
                    <b-field
                        label="Код"
                        label-position="on-border"
                        v-for="(item, i) in form.items"
                        :key="i + 200"
                    >
                        <b-input v-model="item.code"></b-input>
                    </b-field>
                </div>
                <div class="column is-2">
                    <b-field
                        label="Сортировка"
                        label-position="on-border"
                        v-for="(item, i) in form.items"
                        :key="i + 300"
                    >
                        <b-input v-model.number="item.sort"></b-input>
                    </b-field>
                </div>
            </div>
        </b-field>
        <div class="field">
            <p class="control">
                <b-button type="is-primary is-light" size="is-small" @click="addField">
                    Добавить поле
                </b-button>
            </p>
        </div>
    </the-detail-wrapper>
</template>

<style lang="scss"></style>
